import {Button} from "antd";
import s from "./ProjectsHeader.module.css";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {logout} from "../../../store/slices/authSlice";

export const ProjectsHeader = ({name}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = localStorage.getItem("username");
    const handleLogOut = () => {
        localStorage.removeItem("lumitoken");
        localStorage.removeItem("loggedIn");
        localStorage.removeItem("long_lived_token");
        localStorage.clear();
        dispatch(logout());
        navigate("/login", {replace: true});
    };

    return (
        <header className={s.header}>
            <h3>Luminoso: Project Less Clicks</h3>
            <div className={s.headerLogout}>
                {name? <p>{name}</p> : <>{user}</>}
                <Button onClick={handleLogOut}>log out</Button>
            </div>
        </header>
    );
};
